/**
 * Firebase Realtime Database Configuration for Market Analytics
 * Connects to RTDB for real-time market predictions and betting pools
 */

import { getDatabase } from 'firebase/database';
import { app } from '../../../firebase';

// Initialize RTDB with the specific database URL
const RTDB_URL = 'https://just-rhythm-445002-s8-e92d0-513eb.firebaseio.com/';

// Get database instance
export const rtdb = getDatabase(app, RTDB_URL);

// Market data paths configuration
export const MARKET_PATHS = {
  MARKET_GAMES: 'market-games',           // Aggregated game market data
  MARKET_PREDICTIONS: 'market-predictions', // Individual predictions
  BETTING_POOLS: 'betting-pools',         // Pool betting data
  POOL_SETTLEMENTS: 'pool-settlements',   // Settlement history
  LEADERBOARD: 'leaderboard',            // User rankings
  SETTLEMENTS: 'settlements'              // Game results for settlement
};

// Helper to format date to ET timezone YYYY-MM-DD
export const formatDateKey = (date) => {
  const nycDate = new Date(date.toLocaleString("en-US", { timeZone: "America/New_York" }));
  const year = nycDate.getFullYear();
  const month = String(nycDate.getMonth() + 1).padStart(2, '0');
  const day = String(nycDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Helper to get current ET date key
export const getCurrentDateKey = () => {
  return formatDateKey(new Date());
};

// Helper to generate date range for queries
export const getDateRange = (daysBack = 7) => {
  const dates = [];
  const now = new Date();

  for (let i = 0; i < daysBack; i++) {
    const date = new Date(now);
    date.setDate(date.getDate() - i);
    dates.push(formatDateKey(date));
  }

  return dates;
};

// Debug logging for development
export const logMarketData = (action, path, details = {}) => {
  if (process.env.NODE_ENV === 'development') {
    const emoji = {
      'fetch': '📊',
      'update': '📝',
      'error': '🚨',
      'success': '✅',
      'pool': '💰',
      'settlement': '🏁'
    }[action] || '📦';

    console.log(`${emoji} Market Data ${action}:`, path, details);
  }
};

// Sports configuration
export const SUPPORTED_SPORTS = {
  FOOTBALL: 'football',
  NFL: 'nfl',
  NBA: 'nba',
  MLB: 'mlb',
  MMA: 'mma'
};

// Convert sport to lowercase key for RTDB paths
export const getSportKey = (sport) => {
  if (!sport) return 'unknown';
  return sport.toLowerCase();
};

// Pool status enum
export const POOL_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
  SETTLED: 'settled',
  CANCELLED: 'cancelled'
};

// Feature flags
export const MARKET_FEATURES = {
  ENABLE_POOLS: true,
  ENABLE_LEADERBOARD: true,
  ENABLE_LIVE_UPDATES: true,
  DEBUG_MODE: process.env.NODE_ENV === 'development'
};